import { Component, DestroyRef, HostListener, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '@smals/ngx-configuration-service';
import { BnNgIdleService } from 'bn-ng-idle';
import { UserService } from './services/user/user.service';
import { ViewportService } from './services/viewport/viewport.service';
import { RoutingService } from './services/routing/routing.service';
import { DateAdapter } from '@angular/material/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, startWith } from 'rxjs/operators';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    template: `
    <router-outlet/>
    @if (shouldDisplaySpinner){
    <ng-http-loader
      [backgroundColor]="'#3193B9'"
      [filteredUrlPatterns]="['.*app-version.*']"
    ></ng-http-loader>}`,
    standalone: true,
    imports: [RouterOutlet, NgHttpLoaderModule]
})
export class RootComponent implements OnInit {

  private readonly translate = inject(TranslateService);
  private readonly userService = inject(UserService);
  private readonly bnIdle = inject(BnNgIdleService);
  private readonly config = inject(ConfigurationService);
  private readonly viewport = inject(ViewportService);
  private readonly routingService = inject(RoutingService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly dateAdapter = inject(DateAdapter<Date>);
  private readonly router = inject(Router);
  shouldDisplaySpinner;


  ngOnInit(): void {
    this.routingService.initRouting();
    this.viewport.setScreenwidth(window.innerWidth);

    this.getSavedFontSize();

    this.translate.onLangChange
      .pipe(
        map(change => change.lang),
        startWith(this.translate.currentLang),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.dateAdapter.setLocale(this.translate.currentLang === 'de' ? 'de-DE' : `${this.translate.currentLang}-BE`);
      });

    // TimeoutinSeconds
    this.bnIdle.startWatching(this.config.getEnvironmentVariable('maxIdleTimeInSeconds'))
      .subscribe((isTimedOut: boolean) => {
        if (isTimedOut) {
          this.userService.logoutUser();
        }
      });

    window.addEventListener('beforeunload', function (e) {
      this.sessionStorage.clear();
    });
    document.querySelector('html')?.setAttribute('lang', this.translate.currentLang);

    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() =>{
      this.shouldDisplaySpinner= !this.router.url.includes('homepage');
    });
  }

  private getSavedFontSize(): void {
    const fontsize = localStorage.getItem('fontsize');
    document.documentElement.className = (fontsize ? fontsize : 'medium');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?): void {
    this.viewport.setScreenwidth(event.target.innerWidth);
  }
}
